export class WorkOrderVendorProposalFileInfoRawDto {
    fileId: number;
    fileName: string;
    isAccepted: boolean;
}
